export enum ECookieVariable {
  // ======================= User related =======================
  ACCESS_TOKEN_KEY = 'promax_admin_usr_ac_tk',
  USER_REFRESH_TOKEN = 'promax_admin_usr_rf_tk',
  USER_LOCALE = 'promax_admin_locale',
  USER_SYMBOL_ACTIVE_NAME = 'promax_admin_symbol_active_name',
  USER_SYMBOL_ACTIVE_ID = 'promax_admin_symbol_active_id',
  USER_TRADE_COIN = 'promax_admin_trade_coin',
}
